module.exports = __webpack_public_path__ + "static/media/SunIcon.3305ccd0.svg";